module.exports = __webpack_public_path__ + "img/595.6cc1a6c7.jpg";